import { Pipe, PipeTransform } from '@angular/core';
import { AssetTransfer } from '../models/entities/asset-transfer';



@Pipe({
  name: 'asset-transfer-pipe'
})

export class AssetTransferPipe implements PipeTransform {
  
  constructor(){}


  transform(assetTransfer: AssetTransfer, field: string): any {
    let result = assetTransfer[field];

     if (field == 'progressLevel') {
      if  (result == 0)  return "<div class='label-gray' >"   + 'En cours'            + "</div>";
      if  (result == 10) return "<div class='label-orange' >" + 'Expédiée'            + "</div>";
      if  (result == 15) return "<div class='label-red' >"    + 'Réception Partielle' + "</div>";
      if  (result == 20) return "<div class='label-green' >"  + 'Réceptionnée'        + "</div>";
    }

    return result;
  }
}
